/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'

/**
 *
 * @export
 * @interface EnvelopedServiceLocationSeoFieldsDestroyAdmin
 */
export interface EnvelopedServiceLocationSeoFieldsDestroyAdmin {
  /**
   *
   * @type {any}
   * @memberof EnvelopedServiceLocationSeoFieldsDestroyAdmin
   */
  body: any | null
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedServiceLocationSeoFieldsDestroyAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedServiceLocationSeoFieldsDestroyAdmin interface.
 */
export function instanceOfEnvelopedServiceLocationSeoFieldsDestroyAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedServiceLocationSeoFieldsDestroyAdminFromJSON(
  json: any,
): EnvelopedServiceLocationSeoFieldsDestroyAdmin {
  return EnvelopedServiceLocationSeoFieldsDestroyAdminFromJSONTyped(json, false)
}

export function EnvelopedServiceLocationSeoFieldsDestroyAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedServiceLocationSeoFieldsDestroyAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: json['body'],
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedServiceLocationSeoFieldsDestroyAdminToJSON(
  value?: EnvelopedServiceLocationSeoFieldsDestroyAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: value.body,
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
